module["exports"] = [
  "#{street_root}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de/address/street_name.js
 ** module id = 209
 ** module chunks = 0
 **/